import React, { useState } from 'react';
import { Keyboard } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { errMsg } from '@/services/staffAttendanceApi';
import { holdsApi } from '@/services/ewayBillApi';
import { KeyEwbForm } from '@/components/ewayBill/KeyEwbBox';

/** Held row whose e-way bill was made directly on the GST portal: type its details → Active e-way bill, off the list. */
export const HoldKeyEwb = ({ h, id, disabled, onDone }) => {
  const [open, setOpen] = useState(false);
  const save = (body) => holdsApi.keyEwb({ doc_no: h.doc_no, doc_type: h.doc_type || 'customer_invoice', ...body })
    .then((b) => { toast.success(`${h.doc_no}: EWB No ${b.ewb_no} saved — the e-way bill is Active`); setOpen(false); onDone(); })
    .catch((e) => {
      toast.error(errMsg(e, 'Could not save the EWB No'), { duration: 8000 });
      if (e?.response?.status === 409 && /already has an e-way bill/.test(e.response.data?.detail || '')) { setOpen(false); onDone(); }
    });
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" variant="outline" className="h-8" disabled={disabled} title="Made it on the GST portal? Type in its EWB No" data-testid={`hold-key-open-${id}`}>
          <Keyboard className="w-4 h-4 mr-1" />Type in EWB No</Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[640px] max-w-[95vw] p-2">
        <KeyEwbForm save={save} onCancel={() => setOpen(false)} tid={`hold-key-${id}`}
          note={`Made the e-way bill for ${h.doc_no} directly on the GST portal? Type the details from the portal print — it becomes an Active e-way bill and leaves this list.`} />
      </PopoverContent>
    </Popover>
  );
};

export default HoldKeyEwb;
